import { ImgHTMLAttributes } from 'react'
import { getUriForStaticDocs } from '../services/api'

interface IApiImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  url: string
}

export function ApiImage({ url, width, ...rest }: IApiImageProps) {
  return (
    <img
      {...rest}
      width={width}
      src={`${getUriForStaticDocs}/uploads/${url}`}
    />
  )
}
